<div class="calendar-container">
  <!-- Calendar Header -->
  <div class="calendar-header">
    <div class="flex items-center gap-4">
      <h2 class="text-2xl font-bold text-gray-900 dark:text-white">
        {{ monthNames[currentMonth] | translate }} {{ currentYear }}
      </h2>
      <div class="flex gap-2">
        <p-button
          icon="pi pi-chevron-left"
          (onClick)="previousMonth()"
          [rounded]="true"
          [text]="true"
          size="small"
          />
        <p-button
          [label]="'common.today' | translate"
          (onClick)="today()"
          [outlined]="true"
          size="small"
          />
        <p-button
          icon="pi pi-chevron-right"
          (onClick)="nextMonth()"
          [rounded]="true"
          [text]="true"
          size="small"
          />
      </div>
    </div>
  </div>

  <!-- Calendar Grid -->
  <div class="calendar-grid">
    <!-- Week days header -->
    <div class="calendar-weekdays">
      @for (day of weekDays; track day) {
        <div class="calendar-weekday">
          {{ day | translate }}
        </div>
      }
    </div>

    <!-- Calendar days -->
    <div class="calendar-days">
      @for (day of calendarDays; track day; let dayIndex = $index) {
        <div
          class="calendar-day"
          [class.other-month]="!day.isCurrentMonth"
          [class.today]="day.isToday"
          [class.day-full]="isDayFull(day)"
          (click)="onDateClick(day)"
          (keyup.enter)="onDateClick(day)"
          (keyup.space)="onDateClick(day)"
          tabindex="0"
          role="button"
          [attr.aria-label]="'Select ' + day.date.toDateString()"
          >
          <!-- Day number and availability indicator -->
          <div class="day-header">
            <div class="day-number">
              {{ day.date.getDate() }}
            </div>
            @if (day.reservations.length > 0 || isDayFull(day)) {
              <div
                class="bed-indicator"
                [class.beds-available]="!isDayFull(day)"
                [class.beds-full]="isDayFull(day)"
            [pTooltip]="
              isDayFull(day)
                ? 'Sin camas disponibles'
                : getAvailableBeds(day) + ' cama(s) disponible(s)'
            "
                >
                <i
                  class="pi"
                  [class.pi-check-circle]="!isDayFull(day)"
                  [class.pi-times-circle]="isDayFull(day)"
                ></i>
                {{ day.reservations.length }}/{{ maxBedsPerDay }}
              </div>
            }
          </div>
          <!-- Reservations for this day (Drop Zone) -->
          <div
            class="day-reservations"
            cdkDropList
            [id]="getDropListId(dayIndex)"
            [cdkDropListData]="day.reservations"
            [cdkDropListConnectedTo]="connectedDropLists"
            [cdkDropListEnterPredicate]="canDropPredicate(day)"
            (cdkDropListDropped)="onDrop($event, day)"
            [class.drop-zone-active]="!isDayFull(day)"
            [class.drop-zone-full]="isDayFull(day)"
            >
            @for (reservation of day.reservations; track reservation; let i = $index) {
              <div
                class="reservation-bar"
                cdkDrag
                [cdkDragData]="reservation"
                [class.reservation-start]="getReservationPosition(reservation, day) === 'start'"
                [class.reservation-middle]="getReservationPosition(reservation, day) === 'middle'"
                [class.reservation-end]="getReservationPosition(reservation, day) === 'end'"
                [class.reservation-single]="getReservationPosition(reservation, day) === 'single'"
                [style.background-color]="getStatusColor(reservation.status)"
            [pTooltip]="
              reservation.patientName +
              ' - Habitación ' +
              reservation.roomNumber +
              ' - Arrastrar para mover'
            "
                tooltipPosition="top"
                (click)="onReservationClick(reservation, $event)"
                (keyup.enter)="onReservationClick(reservation, $event)"
                (keyup.space)="onReservationClick(reservation, $event)"
                tabindex="0"
                role="button"
                [attr.aria-label]="reservation.patientName + ' reservation - drag to move'"
                >
                <!-- Drag handle icon -->
                <i class="pi pi-arrows-alt drag-handle" cdkDragHandle></i>
                <span class="reservation-label">
                  {{ reservation.patientName }} - Hab. {{ reservation.roomNumber }}
                </span>
                <!-- Placeholder mientras se arrastra -->
                <div *cdkDragPlaceholder class="reservation-placeholder"></div>
              </div>
            }
            <!-- Empty state cuando no hay reservaciones -->
            @if (day.reservations.length === 0 && day.isCurrentMonth) {
              <div class="empty-day-hint">
                <span class="text-xs text-gray-400">Soltar aquí</span>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
